export function addDashes(sortCode: string | null) {
  return sortCode && sortCode.slice(0, 2) + '-' + (sortCode + '').slice(2, 4) + '-' + (sortCode + '').slice(4);
}